<script lang="ts">

    import { openModal } from 'svelte-modals';
    import JobPhotosModal from './JobPhotosModal.svelte';

    export let photos: string[] = [];
    export let title: string = '';

    let photoURLs = photos.map((ph) => 'https://img.targeo.pl/i/cache/'+ph);

    function showPhoto(url: string) {
        openModal(JobPhotosModal, {photos: photoURLs, current: photoURLs.indexOf(url)});
    }
</script>

<div>
    {#if title}
        <div class="title">{title}</div>
    {/if}
    {#each photoURLs as url}
        <img src={url.replace(/\.(jpe?g|png)$/, '-mini.$1')} class="job-photo" on:click={() => { showPhoto(url); }}/>
    {/each}
</div>

<style>
    .title {
        font-style: italic;
        font-size: 80%;
        white-space: nowrap;
        margin-bottom: 3px;
    }
    .job-photo {
        border: 1px solid #555;
        padding: 3px;
        margin: 0 5px;
    }

</style>
